<template>
  <div>
    <BasicModal
      :title="chatbot.is_archive ? 'ロボ一覧に戻す':'アーカイブ'"
      :isShowModal="isShowModal"
      :canCancel="true"
      @cancel="cancel">
      <div class="action-container" v-if="!chatbot.is_archive">
        アーカイブしますか？
      </div>
      <div class="action-container" v-else>
        ロボ一覧に戻しますか？
      </div>
      <!-- フッターアクション -->
      <div class="footer-box">
        <button class="button" @click="cancel">いいえ</button>
        <button class="button is-primary" @click="archiveChatBot(chatbot)">はい</button>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  components: {
    BasicModal
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true,
    },
    chatbot: {
      type: Object,
      required: true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    archiveChatBot (chatbot) {
      if (chatbot.is_archive) {
        this.sendControlLogRelatedChatBot('ロボ　アーカイブから戻す', 'ロボ詳細画面にて、アーカイブされているロボを一覧に戻した。', chatbot)
      }
      else {
        this.sendControlLogRelatedChatBot('ロボ　アーカイブ', 'ロボ詳細画面にて、ロボをアーカイブした。', chatbot)
      }
      chatbot.is_archive = !chatbot.is_archive
      this.$emit('cancel', false)
      this.$emit('archiveChatBot', chatbot)
    }
  }
}
</script>

<style lang="scss" scoped>
.action-container {
  padding: 16px;
  h2 {
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    text-align: left;
    margin-bottom: 16px;
  }
  button {
    width: 47%;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailArchiveDelete.vue